// MUI
import { Dialog, DialogContent, DialogTitle, IconButton, List, ListItem, Typography } from "@mui/material";

// Types
import { IProspectNoteDialogContent } from "../types/salesLeads";

// Icons
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import RenderProspectNoteItem from "./RenderProspectNoteItem";

interface IProspectNoteDialogProps {
	handleOnCloseDialog: () => void;
	dialogContent: IProspectNoteDialogContent | null;
}

const ProspectNoteDialog = (props: IProspectNoteDialogProps) => {
	const { handleOnCloseDialog, dialogContent } = props;
	const { title, data = [] } = dialogContent ?? {};

	if (!dialogContent) {
		return null;
	}

	return (
		<Dialog
			classes={{
				paper: "!rounded-[10px] !shadow-md p-4",
			}}
			open={dialogContent !== null}
			onClose={handleOnCloseDialog}
			PaperProps={{
				style: {
					minWidth: "580px",
					maxWidth: "800px",
					maxHeight: "50vh",
				},
			}}
			disableEscapeKeyDown
			onDoubleClick={(e) => {
				e.stopPropagation();
			}}
		>
			<DialogTitle>
				<Typography className={"!font-montserrat !text-lg !font-medium !text-default"}>{title}</Typography>
				<IconButton className="!absolute !right-1 !top-1 !text-default" aria-label="close" onClick={handleOnCloseDialog}>
					<CloseRoundedIcon fontSize="medium" />
				</IconButton>
			</DialogTitle>
			<DialogContent className="mb-4">
				<List>
					{data.map((item, index) => {
						const key = `${index}`;
						const isLast = index === data.length - 1;
						return (
							<ListItem key={key} divider={!isLast} disablePadding className="!py-2">
								<RenderProspectNoteItem key={key} item={item} />
							</ListItem>
						);
					})}
				</List>
			</DialogContent>
		</Dialog>
	);
};

export default ProspectNoteDialog;
